import api from "../../../services/api";

export interface ChannelPerformanceRaw {
  channel: string;
  shopify_revenue?: number;
  shopify_order_count?: number;
  shopify_units_sold?: number;
  wholesale_revenue?: number;
  wholesale_order_count?: number;
  wholesale_units_sold?: number;
  average_order_value: number;
}

export interface CategoryPerformance {
  category: string;
  units_sold: number;
  average_price: number;
  revenue: number;
  average_order: number;
}

export interface CollectionPerformance {
  collection_code: string;
  collection_description: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface ColorPerformance {
  color: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface SizePerformance {
  size: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface GenderEcommCategoryReport {
  category: string;
  units_sold: number;
  revenue: number;
}

export interface SKUPerformance {
  sku: string;
  product_name: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface CompletePerformance {
  style: string;
  color: string;
  size: string;
  gender: string;
  category: string;
  collection: string;
  product_name: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface TopProductsPerformance {
  style: string;
  title: string;
  image_src: string;
  units_sold: number;
  average_price: number;
  revenue: number;
}

export interface EcommSalesRawResponse {
  start_date: string;
  end_date: string;
  prev_start_date: string;
  prev_end_date: string;
  total_revenue: number;
  total_orders: number;
  total_units_sold: number;
  average_order_value: number;
  prev_total_revenue: number;
  prev_total_orders: number;
  prev_total_units_sold: number;
  prev_average_order_value: number;
  revenue_growth: number;
  order_growth: number;
  units_growth: number;
  average_order_growth: number;
  channel_performance: ChannelPerformanceRaw[];
  shopify_category_performance: CategoryPerformance[];
  wholesale_category_performance: CategoryPerformance[];
  shopify_collection_performance: CollectionPerformance[];
  shopify_color_performance: ColorPerformance[];
  shopify_size_performance: SizePerformance[];
  shopify_sku_performance: SKUPerformance[];
  shopify_complete_performance: CompletePerformance[];
  shopify_top_products_performance: TopProductsPerformance[];
}

export const fetchEcommSales = async (
  start_date: string,
  end_date: string
): Promise<EcommSalesRawResponse> => {
  const response = await api.get("/api/shopify/sales_reports/dashboard", {
    params: { start_date, end_date },
  });
  return response.data;
};
